import React from "react";

import "./SentimentIcons.scss";
import { FaceIcon } from "@atsent/components";

export type SentimentIconsProps = {
  cx?: string;
};

export const SentimentIcons: React.FC<SentimentIconsProps> = ({ cx = "" }) => {
  return (
    <div className={`SentimentIcons ${cx}`}>
      <div>
        <span>긍정</span>
        <FaceIcon cx={"positive-1"} />
      </div>
      <div>
        <span>중립</span>
        <FaceIcon cx={"neutral"} />
      </div>
      <div>
        <span>부정</span>
        <FaceIcon cx={"negative-1"} />
      </div>
    </div>
  );
};
